import { useEffect, useState } from 'react';
import { useAuth } from '../app/auth';
import { retryPendingUploads } from '../drafts/sync';

/** Çevrimdışı bilgisi + bağlantı gelince yükleme bekleyen taslakları dener. */
export function OfflineBanner() {
  const { me } = useAuth();
  const [online, setOnline] = useState(navigator.onLine);
  useEffect(() => {
    const on = () => { setOnline(true); if (me) void retryPendingUploads(me.user.id); };
    const off = () => setOnline(false);
    window.addEventListener('online', on);
    window.addEventListener('offline', off);
    return () => { window.removeEventListener('online', on); window.removeEventListener('offline', off); };
  }, [me]);
  if (online) return null;
  return (
    <div className="alert warn" role="status" style={{ borderRadius: 0 }}>
      Çevrimdışısınız. Fotoğraf ve alanları taslak olarak hazırlayabilirsiniz; kayıt ve toplamlar bağlantı gelince
      siz gönderdiğinizde kesinleşir.
    </div>
  );
}
